import React from 'react';

import CrudForm from '../../../Form/CrudForm';
import DeclarationForm from './DeclarationForm';

import {
  borrowerFields,
  addressFields,
  employmentFields,
  declarationFields,
} from './fields';

export default function BorrowerForm({
  createBorrower,
  borrower,
  updateBorrower,
  isPending,
  currentTab,
}) {
  let currentFeilds = [];
  switch (currentTab) {
    case 'Borrower':
      currentFeilds = borrowerFields;
      break;
    case 'Address':
      currentFeilds = addressFields;
      break;
    case 'Employment':
      currentFeilds = employmentFields;
      break;
    case 'Declarations':
      currentFeilds = declarationFields;
      break;
    default:
      break;
  }

  if (currentTab === 'Declarations') {
    return (
      <DeclarationForm
        fields={currentFeilds}
        borrower={borrower}
        updateBorrower={(formValues) =>
          updateBorrower({ formValues, borrowerId: borrower.id })
        }
        createBorrower={createBorrower}
        isPending={isPending}
      />
    );
  }

  return (
    <div>
      <CrudForm
        fields={currentFeilds}
        createHandler={createBorrower}
        submitButtonLabel={borrower ? 'Update Borrower' : 'Create Borrower'}
        updateHandler={(formValues) =>
          updateBorrower({ formValues, borrowerId: borrower.id })
        }
        data={borrower}
        disabled={isPending}
      />
    </div>
  );
}
